module.exports = __webpack_public_path__ + "static/media/ic-website.020adc98.svg";